import { Suspense } from "react";
import { Await, useLoaderData, defer } from "react-router-dom";
import ApiServices from "../../service/ApiServices";

import { Spinner } from "../template/spinner/spinner";
import { LiqPay } from "./liqpay/liqpay";

const Checkout = () => {

    const {data, payment} = useLoaderData();

    return (
       <div>
            <Suspense fallback={< Spinner />}>
                <Await resolve={data}> 
                    {payment === "liqpay" &&
                        <LiqPay/>
                    }
                </Await>
            </Suspense>
       </div>
    )
}

const res = new ApiServices();

const checkoutLoader = () => {
    const cart = localStorage.getItem('cartId');
    const payment = localStorage.getItem('payment');
    let payMethod;

    if (payment === "liqpay") {
        payMethod = res.getLiqPayData(cart);
    }

    return defer({
        data: payMethod,
        payment: payment,
    })
}

export {Checkout, checkoutLoader};